// namespace
export const STORE_NAMESPACE = 'toasts'
// mutations
export const SET_ALERT = 'SET_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'

const state = () => ({
  showToast: false,
  toastData: {},
})

const actions = {
  showToast({ commit }, payload) {
    commit(SET_ALERT, payload)
    setTimeout(() => {
      commit(REMOVE_ALERT)
    }, payload.delay || 2100)
  },
}

const mutations = {
  [SET_ALERT](state, data) {
    state.toastData = data
    state.showToast = true
  },
  [REMOVE_ALERT](state) {
    state.toastData = {}
    state.showToast = false
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
